import Controller from './pedagogicalApproachParameterController';
import './pedagogicalApproachParameter.scss';

const PedagogicalApproachParameterComponent = {
    template: require('./singleParameterView.html'),
    controller: Controller
};

export default PedagogicalApproachParameterComponent;


// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepMiniPedagogicalApproach/singleParameterView/pedagogicalApproachParameterComponent.js